import { render, staticRenderFns } from "./RankOrderUiComponent.vue?vue&type=template&id=02b6ac35&"
import script from "./RankOrderUiComponent.vue?vue&type=script&lang=ts&"
export * from "./RankOrderUiComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports